import { WizardTranslations } from "./wizard-pt-br";

export const WIZARD_ES_ES: WizardTranslations = {
	common: {
		pointsOfSale: "Puntos de venta",
	},
	welcome: {
		title: "¡Bienvenido, <placeName>{{placeName}}</placeName>!",
		subtitle: "Elige cómo quieres configurar tu operación.",
		skipButton: "No quiero configurar ahora",
		placeIdNotFound: "ID de lugar no encontrado",
		features: {
			preConfiguredSteps: "Pasos con sugerencias preconfiguradas",
			guidedStepsWithAI: "Paso a paso guiado con ayuda de IA",
			advancedConfigurations: "Configuraciones avanzadas y personalizaciones",
			complexFeatures: "Funcionalidades más complejas",
		},
		guidedMode: {
			title: "Creación guiada (modo simplificado)",
			subtitle: "Te guiamos paso a paso",
			buttonText: "Acceder al modo simplificado",
			features: {
				basicConfigurations: "Configuraciones más básicas",
				idealForSimpleOperations: "Ideal para operaciones más simples y pequeñas",
			},
		},
		advancedMode: {
			title: "Creación avanzada",
			subtitle: "Más opciones y detalles de configuración",
			buttonText: "Acceder al modo avanzado",
			features: {
				directConfiguration: "Configuración directa en los módulos del Dashboard",
				idealForComplexOperations: "Ideal para operaciones grandes y complejas",
			},
		},
	},
	container: {
		stepIndexTitle: "Configura tu local",
		buttons: {
			back: "Volver",
			close: "Cerrar",
			next: "Siguiente",
			configureLater: "Configurar después",
			finishConfiguration: "Concluir configuraciones",
		},
		finishConfirmation: {
			title: "Concluir configuraciones de la operación",
			descriptionPart1: "Estás a punto de concluir la configuración de esta operación.",
			descriptionPart2:
				"Se generará un resumen final que estará disponible para consulta en cualquier momento. Después, podrás revisar y editar cuando lo necesites.",
			cancelButton: "Cancelar",
			confirmButton: "Concluir configuraciones",
			successMessage: "¡Configuraciones guardadas con éxito!",
		},
		closeModalConfirmation: {
			title: "¿Salir de la configuración sin guardar?",
			description:
				"Al cerrar ahora, la información configurada hasta aquí no se guardará y perderás el progreso. ¿Deseas continuar?",
			cancelButton: "Continuar configurando",
			confirmButton: "Salir sin guardar",
		},
		steps: {
			basicInformation: {
				title: "Información básica",
				subtitle: "Configura el tipo de operación",
				operationType: {
					title: "¿Cómo <highlight>comprarán</highlight> los clientes?",
					subtitle: "Elige uno o más formatos que se aplicarán a esta operación.",
					alert: {
						message: "Estas opciones ya vienen marcadas del contrato de tu operación.",
						description: "Puedes mantenerlo como está o ajustarlo si lo deseas.",
					},
					subStepTitle: "Tipo de operación",
				},
				funcionalities: {
					title:
						"¿Qué serán las <highlight>funcionalidades</highlight> de esta operación?",
					subtitle:
						"Las funcionalidades son opciones con recursos que permiten configurar la operación de forma personalizada.",
					subStepTitle: "Funcionalidades",
					searchFunctionalities: "Buscar por funcionalidades",
					placeholderSearchFunctionalities: "Ingrese aquí la funcionalidad",
					activeLabel: "activas",
					loadingText: "Cargando funcionalidades...",
					emptySearchResults: "Ninguna funcionalidad encontrada",
				},
				review: {
					title:
						"¡Ya entendimos las <highlight>configuraciones iniciales</highlight> de la operación!",
					subtitle: "De acuerdo con tus respuestas, el sistema configurará:",
					subStepTitle: "Revisión",
					reviewTitle: "Revisa las respuestas",
					reviewSubtitle: "Podrás editarlas ahora o cuando lo necesites.",
					editStep: "Editar etapa",
					operationTypeLabel: "Tipo de operación",
					functionalitiesLabel: "Funcionalidades",
					notInformed: "No informado",
					selectedCount: "{{count}} seleccionada(s)",
					viewFunctionalities: "Ver funcionalidades",
				},
			},
			pointsOfSale: {
				title: "Puntos de venta",
				subtitle: "Configura los locales de venta",
			},
			menu: {
				title: "Carta",
				subtitle: "Configura los productos",
			},
			employees: {
				title: "Empleados",
				subtitle: "Configura el equipo de la operación",
			},
		},
		operationTypes: {
			token: {
				label: "Ficha",
				description: "El cliente cambia ficha por producto",
			},
			cashlessPrepaid: {
				label: "Cashless (prepago)",
				description: "El cliente carga crédito en una tarjeta",
			},
			cashlessPostpaid: {
				label: "Cashless (pospago)",
				description: "El cliente paga en una tarjeta después del consumo",
			},
			directSale: {
				label: "Venta directa en barra",
				description: "El cliente paga el producto directamente",
			},
			tables: {
				label: "Mesas",
				description: "El cliente realiza el pedido a los camareros",
			},
		},
		summary: {
			title: "¡Resumen de la configuración de <placeName>{{placeName}}</placeName>!",
			subtitle:
				"Edita respuestas, vuelve etapas o accede a configuraciones avanzadas en cualquier momento.",
			editStep: "Editar etapa",
			operationType: "Tipo de operación",
			functionalities: "Funcionalidades",
			viewFunctionalities: "Ver funcionalidades",
			advancedConfigurations: "Configuraciones avanzadas de Funcionalidades",
			notInformed: "No informado",
			pendingAction: "Acción pendiente",
			loading: "Cargando configuraciones...",
			placeIdNotFound: "ID de lugar no encontrado",
			errorLoading: "Error al cargar datos",
		},
	},
	components: {
		pdvCard: {
			menu: {
				edit: "Editar",
				remove: "Eliminar",
				ariaLabel: "Menú de opciones",
			},
			buttons: {
				cancel: "Cancelar",
				save: "Guardar",
			},
		},
		productCard: {
			menu: {
				edit: "Editar",
				remove: "Eliminar",
				ariaLabel: "Menú de opciones",
			},
		},
		menuCard: {
			productsCount: "{{count}} productos",
		},
		empty: {
			title: "No hay datos para exibir",
			description: "Parece que no hay datos para exibir.",
			button: "Agregar nuevo item",
		},
		attachmentsFile: {
			loadingText: "Espere mientras enviamos el archivo...",
			dragText: "Arrastre y suelte el archivo",
			clickText: "o haga clic para seleccionar",
			fileTypeText: "Tipo de archivo {{fileType}} hasta {{fileSize}}.",
			maxSizeExceeded: "El tamaño del archivo excede el límite permitido.",
		},
		modalSelectImage: {
			productImage: "Editar imagen",
			setTagInput: "busque el producto usando palabras clave",
			notInformed: "Nombre no informado",
			confirm: "Confirmar",
			selectFrom: "Seleccione imagen de su ",
			computer: "computador",
			addImage: "Agregar imagen",
			typeOfFile: "Tipo de archivo .jpg, .jpeg, .png hasta 5MB",
			errorCreatingImageUrl: "Error al crear la URL de la imagen",
		},
		employeePdvLink: {
			manualDistribution: "Distribuir manualmente",
			description:
				"Elija para qué puntos de venta todos los <strong>{{count}} {{roleName}}</strong> van a trabajar",
			selectedCount: "{{count}} Seleccionados",
		},
	},
};
